import unsplash from "../api/unsplash";
import userApi from "../api/user-api";
import backendApi from "../api/backend-api";

export const incrementCounter = () => {
  return {
    type: "INCREMENT_COUNTER",
    payload: {
      value: 1
    }
  };
};

export const decrementCounter = () => {
  return {
    type: "DECREMENT_COUNTER",
    payload: {
      value: 1
    }
  };
};

export const getImages = () => {
  return async function(dispatch, getState) {
    const response = await unsplash.get("/search/photos", {
      params: {
        query: "cat",
        page: 1
      }
    });

    dispatch({
      type: "IMAGES_READED",
      payload: {
        images: response.data.results
      }
    });
  };
};

export const getImages2 = () => async dispatch => {
  const response = await unsplash.get("/search/photos", {
    params: {
      query: "cat",
      page: 1
    }
  });

  dispatch({
    type: "IMAGES_READED",
    payload: { images: response.data.results }
  });
};

export const getUsers = () => {
  return async function(dispatch, getState) {
    const response = await userApi.get("/users", {
      params: {
        query: "cat",
        page: 1
      }
    });

    dispatch({ type: "GET_USERS", payload: { users: response.data } });
  };
};

export const getUser = id => {
  return async function(dispatch, getState) {
    const response = await userApi.get("/users/" + id, {
      params: {
        id: id
      }
    });
    dispatch({ type: "GET_USER", payload: { user: response.data } });
    return response.data;
  };
};

export const getCountries = () => {
  return async function(dispatch, getState) {
    const response = await userApi.get("/countries/", {
      params: {}
    });
    dispatch({ type: "GET_COUNTRIES", payload: { countries: response.data } });
  };
};

export const getStates = countryId => {
  return async function(dispatch, getState) {
    if (countryId) {
      const response = await userApi.get("/states/", {
        params: {
          countryId: countryId
        }
      });
      dispatch({ type: "GET_STATES", payload: { states: response.data } });
    } else {
      dispatch({ type: "GET_STATES", payload: { states: [] } });
    }
  };
};

export const getCities = (countryId, stateId) => {
  return async function(dispatch, getState) {
    if (countryId && stateId) {
      const response = await userApi.get("/cities/", {
        params: {
          countryId: countryId,
          stateId: stateId
        }
      });
      return dispatch({ type: "GET_CITIES", payload: { cities: response.data } });
    } else {
      return dispatch({ type: "GET_CITIES", payload: { cities: [] } });
    }
  };
};

export const getLastJobs = () => {
  return async function(dispatch, getState) {
    const response = await backendApi.post("/api/peticiones/find-all-published/", {
      }, {
      params: {
        searchText: null,
        page: null,
        size: 3,
        sort: "lastModifiedAt,desc"
      }
    });
    console.log("primeros tres", response.data.data.content);
    return dispatch({ type: "GET_LAST_JOBS", payload: response.data.data.content });
  };
};

export const getPublishedJobs = (searchInfo) => {
  return async function(dispatch, getState) {
    let searchText = '';

    if (searchInfo.keywords)
      searchText += searchInfo.keywords;
    if (searchInfo.localization)
      searchText += ' ' + searchInfo.localization;

    const response = await backendApi.post("/api/peticiones/find-all-published/", {
        salarioMaximoFrom: searchInfo.minSalary,
        salarioMaximoTo: searchInfo.maxSalary/*,
        provincia: searchInfo.localization ? {
          id: searchInfo.localization
        } : null*/
      }, {
      params: {
        searchText: searchText,
        page: searchInfo.page != null ? searchInfo.page : null,
        size: searchInfo.size != null ? searchInfo.size : null,
        sort: "lastModifiedAt,desc"
      }
    });
    //console.log("get published jobs", response.data.data);
    return dispatch({ type: "GET_PUBLISHED_JOBS", payload: response.data.data });
  };
};

export const getJob = (id) => {
  return async function(dispatch, getState) {
    const response = await backendApi.get("/api/peticiones/" + id, {
      
    });
    console.log("get job", response.data.data);
    return dispatch({ type: "GET_JOB", payload: response.data.data });
  };
};

export const addCandidate = (id, formValues) => {
  return async function(dispatch, getState) {
    let formData = new FormData();
    formData.append("model", JSON.stringify({
      nombre: formValues.nombre,
      apellidos: formValues.apellidos,
      email1: formValues.email1,
      telefono1: formValues.telefono1
    }));
    formData.append("file", formValues.cv[0]);
    //formData.append('profile_pic', data.profile_pic[0])
    console.log("input form values addCandidate", formValues);
    console.log("addCandidate", formData);

    const response = await backendApi.post("/api/peticiones/" + id + "/candidatos", formData, {
      headers: { 'content-type': 'multipart/form-data' }
    });
    //console.log("get job", response.data.data);
    return dispatch({ type: "ADD_CANDIDATE", payload: response.data.data });
  };
};

export const acceptLopd = (formValues) => {
  return async function(dispatch, getState) {
    let formData = new FormData();
    formData.append("model", JSON.stringify({
      nombre: formValues.nombre,
      apellidos: formValues.apellidos,
      email1: formValues.email1,
      telefono1: formValues.telefono1
    }));
    if (formValues.cv != null && formValues.cv.length > 0) {
      formData.append("file", formValues.cv[0]);
    }
    console.log("input form values addCandidate", formValues);
    console.log("addCandidate", formData);

    const response = await backendApi.post("/api/candidatos/accept-lopd", formData, {
      headers: { 'content-type': 'multipart/form-data' }
    });
    //console.log("get job", response.data.data);
    return dispatch({ type: "ACCEPT_LOPD", payload: response.data.data });
  };
};

export const updateSearchJobsParams = (search) => {
  return function(dispatch, getState) {
    return dispatch({ type: "PREPARE_SEARCH", payload: search });
  };
};

export const requestContact = (formValues) => {
  return async function(dispatch, getState) {
    const response = await backendApi.post("/api/users/request-contact/", formValues, {
      params: {}
    });
    //console.log("get published jobs", response.data.data);
    return dispatch({ type: "POST_REQUEST_CONTACT", payload: response.data.data });
  };
};